import { render, staticRenderFns } from "./orderNoticeList.vue?vue&type=template&id=06be6cb8&scoped=true&"
import script from "./orderNoticeList.vue?vue&type=script&lang=js&"
export * from "./orderNoticeList.vue?vue&type=script&lang=js&"
import style0 from "./orderNoticeList.vue?vue&type=style&index=0&id=06be6cb8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06be6cb8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/vercel/workpath0/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('06be6cb8')) {
      api.createRecord('06be6cb8', component.options)
    } else {
      api.reload('06be6cb8', component.options)
    }
    module.hot.accept("./orderNoticeList.vue?vue&type=template&id=06be6cb8&scoped=true&", function () {
      api.rerender('06be6cb8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/orderNoticeList.vue"
export default component.exports